module.exports = __webpack_public_path__ + "static/media/cake.5765c70d.svg";